import { REHYDRATE } from "redux-persist/constants"

import {
    AUTHENTICATION_LOGIN_REQUEST,
    AUTHENTICATION_LOGIN_RESPONSE,
    AUTHENTICATION_LOGIN_ERROR,
    AUTHENTICATION_LOGIN_UNAUTHORIZED,
    UNAUTHENTICATED,
    AUTHENTICATION_FORGOT_REQUEST,
    AUTHENTICATION_FORGOT_RESPONSE,
    AUTHENTICATION_TOGGLE_FORM
} from "../../actions/action-types"

const defaultState = {
    isLoading: false,
    error: null,
    errorMessage: null,
    isRehydrating: true
}

export default (state = defaultState, { type, error, isLogout, formName }) => {
    switch (type) {
        case AUTHENTICATION_LOGIN_REQUEST:
            return {
                ...state,
                error: null,
                isLoading: true
            }
        case AUTHENTICATION_FORGOT_REQUEST:
            return {
                ...state,
                error: null,
                isLoading: true
            }
        case AUTHENTICATION_LOGIN_ERROR:
            return {
                ...state,
                isLoading: false,
                error: {
                    header: "Sorry!",
                    message: "A problem occurred, please try again later."
                }
            }
        case AUTHENTICATION_LOGIN_UNAUTHORIZED:
            return {
                ...state,
                isLoading: false,
                error: {
                    type: "warning",
                    header: "Incorrect username/password",
                    message:
                        "We can't find the combination of username and password you have entered. Please try again."
                }
            }
        case AUTHENTICATION_LOGIN_RESPONSE:
            return {
                ...state,
                error: null,
                errorMessage: null,
                isLoading: false
            }
        case AUTHENTICATION_FORGOT_RESPONSE:
            return {
                ...state,
                error: null,
                errorMessage: null,
                isLoading: false,
                formName: "resetSuccess"
            }
        case REHYDRATE:
            return {
                ...state,
                isRehydrating: false
            }
        case UNAUTHENTICATED:
            return {
                isLoading: false,
                // isRehydrating is set to false to prevent Main component from loading
                // when UNAUTHENTICATED
                isRehydrating: false,
                error: isLogout
                    ? null
                    : {
                          header: "Session timeout",
                          message:
                              "We're sorry, your session has expired. Please login again."
                      }
            }
        case AUTHENTICATION_TOGGLE_FORM:
            return {
                ...state,
                formName: formName
            }
        default:
            return state
    }
}
